<template>
  <div>
    <vue-headful
      v-if="travelGuide.fields.seo"
      :title="travelGuide.fields.seo.seo_title"
      :description="travelGuide.fields.seo.meta_description"
      url="https://alabama.travel/alabama-vacation-guides"
    />
    <SeoSchema
      v-if="travelGuide.fields.seo"
      :json="travelGuide.fields.seo.schema"
    />
    <div class="brochure-container">
      <div class="avg-header">
        <div class="avg-intro">
          <img
            src="../../public/images/icons/newsletter-logo.svg"
            alt=""
            class="avg-newsletter-logo"
          />
          <h1 class="avg-al-vacation-heading">
            {{ travelGuide.fields.main_header }}
          </h1>
          <p
            v-html="travelGuide.fields.main_paragraph"
            class="avg-al-vacation-tx"
          ></p>
          <p class="avg-note">{{ travelGuide.fields.disclaimer }}</p>
          <p class="avg-guide-link">
            <router-link to="/online-vacation-guide" target="_blank" rel="noopener noreferrer"
              >View Online</router-link
            >
          </p>
        </div>
        <div class="avg-get-guide">
          <img
            src="https://alabama-travel.s3.amazonaws.com/assets/AVG2024+Cover.jpg"
            width="375"
            height="509"
            alt=""
            class="avg-guide"
          />
          <div class="avg-order-form">
            <div class="avg-order-form-content">
              <div v-if="!showConfirmation" class="avg-get-the-guide">
                Get the guide.
              </div>
              <div v-if="!showConfirmation" class="avg-form-section">
                <div class="avg-order-form-header">
                  <div class="avg-legend">
                    <span
                      :class="
                        showInfo
                          ? 'avg-form-info-bubble-active'
                          : showAddress || showMisc
                          ? 'avg-form-info-bubble-inactive'
                          : ''
                      "
                    ></span>
                    <span
                      :class="
                        showInfo
                          ? 'avg-form-info-active'
                          : showAddress || showMisc
                          ? 'avg-form-info-inactive'
                          : ''
                      "
                      >1</span
                    >
                    <legend
                      :class="
                        showInfo
                          ? 'avg-form-info-active-txt'
                          : showAddress || showMisc
                          ? 'avg-form-info-inactive-txt'
                          : ''
                      "
                    >
                      INFO
                    </legend>
                  </div>
                  <div class="avg-legend">
                    <span
                      :class="
                        showInfo || showMisc
                          ? 'avg-form-address-bubble-inactive'
                          : showAddress
                          ? 'avg-form-address-bubble-active'
                          : ''
                      "
                    ></span>
                    <span
                      style="margin-left: 10px"
                      :class="
                        showInfo || showMisc
                          ? 'avg-form-address-inactive'
                          : showAddress
                          ? 'avg-form-address-active'
                          : ''
                      "
                      >2</span
                    >
                    <legend
                      :class="
                        showInfo || showMisc
                          ? 'avg-form-address-inactive-txt'
                          : showAddress
                          ? 'avg-form-address-active-txt'
                          : ''
                      "
                    >
                      ADDRESS
                    </legend>
                  </div>
                  <div class="avg-legend">
                    <span
                      :class="
                        showInfo || showAddress
                          ? 'avg-form-misc-bubble-inactive'
                          : showMisc
                          ? 'avg-form-misc-bubble-active'
                          : ''
                      "
                    ></span>
                    <span
                      style="margin-bottom: 5px; margin-left: 10px"
                      :class="
                        showInfo || showAddress
                          ? 'avg-form-misc-inactive'
                          : showMisc
                          ? 'avg-form-misc-active'
                          : ''
                      "
                      >3</span
                    >
                    <legend
                      :class="
                        showInfo || showAddress
                          ? 'avg-form-misc-inactive-txt'
                          : showMisc
                          ? 'avg-form-misc-active-txt'
                          : ''
                      "
                    >
                      MISC
                    </legend>
                  </div>
                </div>
                <div>
                  <div v-if="showInfo">
                    <div>
                      <input
                        type="text"
                        class="avg-order-form-field"
                        placeholder="First Name"
                        v-model="form.first_name"
                      />
                    </div>
                    <div class="avg-error-message">
                      <span v-html="firstNameMessage"></span>
                    </div>
                    <div>
                      <input
                        type="text"
                        class="avg-order-form-field"
                        placeholder="Last Name"
                        v-model="form.last_name"
                      />
                    </div>
                    <div class="avg-error-message">
                      <span v-html="lastNameMessage"></span>
                    </div>
                    <div>
                      <input
                        type="email"
                        class="avg-order-form-field"
                        placeholder="Email Address"
                        v-model="form.email"
                      />
                    </div>
                    <div class="avg-error-message">
                      <span v-html="emailMessage"></span>
                    </div>
                    <div>
                      <input
                        type="text"
                        class="avg-order-form-field"
                        placeholder="Company Name (Optional)"
                        v-model="form.company"
                      />
                    </div>
                    <!-- <div class="avg-error-message"><span v-html="companyMessage"></span></div> -->
                    <div class="avg-form-buttons">
                      <input
                        type="button"
                        value="Next"
                        class="avg-submit-btn avg-info-btn"
                        @click="submitBtn('info')"
                      />
                    </div>
                  </div>
                  <div v-if="showAddress">
                    <div>
                      <input
                        type="text"
                        class="avg-order-form-field"
                        placeholder="Street Address"
                        v-model="form.address"
                      />
                    </div>
                    <div class="avg-error-message">
                      <span v-html="addressMessage"></span>
                    </div>
                    <div class="avg-order-form-btn-group-sm">
                      <input
                        type="text"
                        class="avg-order-form-field-short"
                        placeholder="Suite/Apartment"
                        v-model="form.address2"
                      />
                      <input
                        type="email"
                        class="avg-order-form-field-short avg-order-form-field-short-last"
                        placeholder="City"
                        v-model="form.city"
                      />
                    </div>
                    <div class="avg-error-message avg-city-error">
                      <span v-html="cityMessage"></span>
                    </div>
                    <div class="avg-order-form-btn-group-sm">
                      <b-form-select
                        id="State"
                        name="state"
                        v-if="states && states.length > 0"
                        :options="states"
                        v-model="form.state"
                        v-validate="{ required: true }"
                        class="avg-order-form-field-short"
                        aria-placeholder="State"
                      >
                        <template #first>
                          <b-form-select-option :value="null" disabled
                            >State</b-form-select-option
                          >
                        </template>
                      </b-form-select>
                      <input
                        type="email"
                        class="avg-order-form-field-short"
                        placeholder="Zip Code"
                        v-model="form.zip"
                      />
                    </div>
                    <div class="avg-error-message">
                      <span v-html="stateMessage"></span>
                    </div>
                    <div class="avg-error-message avg-zip-error">
                      <span v-html="zipMessage"></span>
                    </div>
                    <div class="avg-form-buttons">
                      <a
                        href="#"
                        class="avg-form-back-btn"
                        @click="submitBtn('info-back')"
                        >Back</a
                      ><input
                        type="button"
                        value="Next"
                        class="avg-submit-btn"
                        @click="submitBtn('address')"
                      />
                    </div>
                  </div>
                  <div v-if="showMisc" class="avg-misc-options">
                    <div class="avg-newsletter-question">
                      <input
                        type="checkbox"
                        class="avg-accept-newsletter-input"
                        v-model="form.newsletter"
                      />
                      <div class="avg-accept-newsletter">
                        <p class="avg-accept-newsletter-txt">
                          <span class="avg-yes-txt">Yes,</span> I'd like to
                          receive the monthly newsletter, exclusive travel tips
                          and special offers from Alabama Tourism.
                        </p>
                      </div>
                      <input
                        type="checkbox"
                        class="avg-accept-newsletter-input"
                        v-model="form.map"
                      />
                      <div class="avg-accept-newsletter">
                        <p class="avg-accept-newsletter-txt">
                          <span class="avg-yes-txt">Yes,</span> I'd like to
                          receive the Official Alabama Highway Map.
                        </p>
                      </div>
                    </div>
                    <div class="avg-select-interests-title">
                      <span>Select what interests you in Alabama State</span>
                      <span class="avg-select-interests-optional">
                        (optional)</span
                      >
                    </div>
                    <div class="avg-brochure-options">
                      <div class="ac">
                        <input
                          type="checkbox"
                          class="avg-brochure-options-input"
                          value="Arts"
                          v-model="interests"
                        />
                        Arts & Cultures
                      </div>
                      <div class="fd">
                        <input
                          type="checkbox"
                          class="avg-brochure-options-input"
                          value="Food"
                          v-model="interests"
                        />
                        Food & Drink
                      </div>
                      <div class="outdoor">
                        <input
                          type="checkbox"
                          class="avg-brochure-options-input"
                          value="Outdoor"
                          v-model="interests"
                        />
                        Outdoor
                      </div>
                      <div class="beaches">
                        <input
                          type="checkbox"
                          class="avg-brochure-options-input"
                          value="Beaches"
                          v-model="interests"
                        />
                        Beaches
                      </div>
                      <div class="history">
                        <input
                          type="checkbox"
                          class="avg-brochure-options-input"
                          value="History"
                          v-model="interests"
                        />
                        History
                      </div>
                      <div class="sd">
                        <input
                          type="checkbox"
                          class="avg-brochure-options-input"
                          value="Science"
                          v-model="interests"
                        />
                        Science & Discovery
                      </div>
                      <div class="crl">
                        <input
                          type="checkbox"
                          class="avg-brochure-options-input"
                          value="CivilRights"
                          v-model="interests"
                        />
                        Civil Rights Legacy
                      </div>
                      <div class="music">
                        <input
                          type="checkbox"
                          class="avg-brochure-options-input"
                          value="Music"
                          v-model="interests"
                        />
                        Music
                      </div>
                      <div class="sports">
                        <input
                          type="checkbox"
                          class="avg-brochure-options-input"
                          value="Sports"
                          v-model="interests"
                        />
                        Sports
                      </div>
                      <div class="yrg">
                        <input
                          type="checkbox"
                          class="avg-brochure-options-input"
                          value="Golf"
                          v-model="interests"
                        />
                        Year Round Golf
                      </div>
                    </div>
                    <div class="avg-form-buttons">
                      <a
                        href="#"
                        class="avg-form-back-submit-btn"
                        @click="submitBtn('address-back')"
                        >Back</a
                      ><input
                        type="button"
                        value="Submit"
                        class="avg-submit-btn avg-submit-btn-last"
                        @click="submitBtn('misc')"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="showConfirmation">
                <div class="avg-confirmation-title">
                  Your guide is on the way
                </div>
                <div>
                  <router-link to="travel-guides#avg-brochures">
                    <input
                      type="button"
                      value="View Brochures"
                      class="avg-confirmation-btn"
                    />
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="brochures" class="avg-title">
        <h2 class="avg-need-more">
          {{ this.travelGuide.fields.secondary_header }}
        </h2>
        <p class="avg-download-tx" id="avg-brochures">
          {{ this.travelGuide.fields.secondary_paragraph }}
        </p>
      </div>
      <div class="avg-brochures">
        <ul class="list-unstyled row avg-brochure-items">
          <li
            v-for="brochure in page.fields.brochures"
            :key="brochure.name"
            class="col col-md-6 col-lg-4 col-xl-3 avg-brochure-row"
          >
            <a :href="brochure.link" download target="_blank" rel="noopener noreferrer">
              <b-img-lazy
                :src="brochure.image"
                :alt="brochure.image_alt_text"
                class="img-fluid avg-brochure-img"
              />
              <div class="avg-brochure-caption">
                <h3 class="avg-brochure-title">{{ brochure.name }}</h3>
                <button type="button" class="avg-download-btn">
                  <img
                    src="../../public/images/icons/atoms-icons-download.svg"
                    class="avg-download-icon"
                  />
                  Download Brochure
                </button>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <TripIdeas2 />
      <Feedback pageType="page" />
      <div class="avg-site-footer"><Footer /></div>
    </div>
  </div>
</template>

<script>
import Footer from '@/components/Common/Footer.vue';
import TripIdeas2 from '@/components/PlacesToGo/Common/TripIdeas2.vue';
import axios from 'axios';
import Butter from 'buttercms';

const butter = Butter('eb418357164849860c223876bb84811162582149');

export default {
  name: 'AlabamaVacationGuides',
  components: { Footer, TripIdeas2 },
  data() {
    return {
      form: {
        state: null,
      },
      interests: [],
      page: {
        fields: {},
      },
      travelGuide: {
        fields: {},
      },
      submitInfo: false,
      submitAddress: false,
      submitMisc: false,
      showInfo: true,
      showAddress: false,
      showMisc: false,
      showConfirmation: false,
      states: [],
      firstNameMessage: '',
      lastNameMessage: '',
      emailMessage: '',
      // companyMessage: '',
      addressMessage: '',
      cityMessage: '',
      stateMessage: '',
      zipMessage: '',
      // eslint-disable-next-line
      warning: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle" viewBox="0 0 16 16"><path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/><path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/></svg>`,
    };
  },
  created() {
    console.log(process.env.VUE_APP_GUIDE_API);
    this.getPage();
    this.populateStates();
  },
  methods: {
    async populateStates() {
      const response = await axios.get('/json/states.json');
      this.states = response.data.map((s) => s.abbr);
    },
    getPage() {
      butter.page
        .retrieve('*', 'alabama-brochures', {
          preview: `${process.env.VUE_APP_BUTTER_PREVIEW}`,
        })
        .then((res) => {
          this.page = res.data.data;
        })
        .catch((res) => {
          console.log(res);
        });

      butter.page
        .retrieve('*', 'travel-guide', {
          preview: `${process.env.VUE_APP_BUTTER_PREVIEW}`,
        })
        .then((res) => {
          this.travelGuide = res.data.data;
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // eslint-disable-next-line
    async submitBtn(type) {
      switch (type) {
        case 'info':
          if (
            this.form.first_name === '' ||
            this.form.first_name === undefined
          ) {
            this.firstNameMessage = `${this.warning} We need your first name.`;
            return;
          }
          this.firstNameMessage = '';

          if (this.form.last_name === '' || this.form.last_name === undefined) {
            this.lastNameMessage = `${this.warning} Looks like you left out your last name.`;
            return;
          }
          this.lastNameMessage = '';

          if (this.form.email === '' || this.form.email === undefined) {
            this.emailMessage = `${this.warning} Please enter a valid email address.`;
            return;
          }
          if (this.validEmail(this.form.email) === false) {
            this.emailMessage = `${this.warning} Double check your email address.`;
            return;
          }
          this.emailMessage = '';

          if (
            this.form.first_name !== undefined &&
            this.form.last_name !== undefined &&
            this.form.email !== undefined &&
            this.form.first_name !== '' &&
            this.form.last_name !== '' &&
            this.form.email !== ''
          ) {
            this.submitInfo = true;
          }
          if (this.submitInfo) {
            this.showInfo = false;
            this.showAddress = true;
            this.showMisc = false;
            this.showConfirmation = false;
          }
          break;
        case 'address':
          if (this.form.address === '' || this.form.address === undefined) {
            this.addressMessage = `${this.warning}
              Looks like someting's missing. Please check your street address`;
            return;
          }
          this.addressMessage = '';

          if (this.form.city === '' || this.form.city === undefined) {
            this.cityMessage = `${this.warning}
              Hang on! Let's make sure that's the correct city name.`;
            return;
          }
          this.cityMessage = '';

          if (!this.form.state) {
            this.stateMessage = `${this.warning}
              Oops! Dont' forget to select or type in a valid state.`;
            return;
          }
          this.stateMessage = '';

          if (this.form.zip === '' || this.form.zip === undefined) {
            this.zipMessage = `${this.warning}
              Double-check that postal code for us, please!`;
            return;
          }
          this.zipMessage = '';

          if (
            this.form.address !== undefined &&
            this.form.city !== undefined &&
            this.form.state &&
            this.form.zip !== undefined &&
            this.form.address !== '' &&
            this.form.city !== '' &&
            this.form.zip !== ''
          ) {
            this.submitAddress = true;
          }
          if (this.submitAddress) {
            this.showInfo = false;
            this.showAddress = false;
            this.showMisc = true;
            this.showConfirmation = false;
          }
          break;
        case 'misc':
          this.showInfo = false;
          this.showAddress = false;
          this.showMisc = false;
          this.showConfirmation = true;
          // eslint-disable-next-line
          let errortext;
          // eslint-disable-next-line
          const interestsString = `{${this.interests.join(',')}}`;
          this.interests = interestsString;
          try {
            await axios
              .post(
                `${process.env.VUE_APP_GUIDE_API}requestVacationGuide`,
                {
                  first_name: this.form.first_name,
                  last_name: this.form.last_name,
                  email: this.form.email,
                  company: this.form.company,
                  address: this.form.address,
                  address2: this.form.address2,
                  city: this.form.city,
                  state: this.form.state,
                  zip: this.form.zip,
                  newsletter: this.form.newsletter
                    ? this.form.newsletter
                    : false,
                  map: this.form.map ? this.form.map : false,
                  interests: interestsString,
                },
                {
                  headers: {
                    'Access-Control-Allow-Origin': '*',
                    Accept: 'application/json',
                  },
                },
              )
              .then(() => {
                this.submitted = true;
                this.$root.$emit('avgSubmitted');
                this.$store.dispatch('guideModal/dismissModal', {
                  date: new Date(),
                  url: this.$router.currentRoute.fullPath,
                  noThanks: true,
                });
              })
              .catch((error) => {
                errortext = error;
              });
          } catch (e) {
            errortext = e;
            // eslint-disable-next-line
            return errortext;
          }
          break;
        case 'view-online':
          break;
        case 'info-back':
          this.showInfo = true;
          this.showAddress = false;
          this.showMisc = false;
          this.showConfirmation = false;
          break;
        case 'address-back':
          this.showInfo = false;
          this.showAddress = true;
          this.showMisc = false;
          this.showConfirmation = false;
          break;
        default:
      }
    },
    getImage(trip) {
      let returnImage = trip.mainImage;
      if (trip.thumbnailImageUrl) {
        returnImage = trip.thumbnailImageUrl;
      } else if (trip.mainImageUrl) {
        returnImage = trip.mainImageUrl;
      }
      return returnImage;
    },
    validEmail(email) {
      // eslint-disable-next-line
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const result = re.test(email);
      return result;
    },
  },
};
</script>

<style lang="scss">
.brochure-container {
  display: flex;
  flex-direction: column;
  gap: 4rem;
  width: 100%;
}

.avg-header {
  display: flex;
  justify-content: center;
  background-image: url('../../public/images/road-trips/background.png');
  background-size: cover;
  background-color: transparent;

  display: flex;
  flex-direction: row;
  gap: 4rem;
  padding-bottom: 4rem;
}

.avg-intro {
  padding-top: 4rem;
  margin-left: auto;
  margin-right: 4rem;
}

.avg-newsletter-logo {
  margin-bottom: 31px;
}

.avg-get-the-guide {
  font-family: 'KlinicSlabbold';
  font-style: normal;
  font-weight: 400;
  font-size: 60px;
  line-height: 62px;
  text-align: center;
  color: #173945;
  margin-top: 2rem;
}

.avg-al-vacation-heading {
  width: 415px;
  height: 170px;
  font-family: 'KlinicSlabbold';
  font-style: normal;
  font-weight: 400;
  font-size: 60px;
  line-height: 62px;
  text-align: center;
  color: #333333;
  margin-bottom: 45px;
}

.avg-al-vacation-tx {
  width: 394px;
  font-family: 'IdealSans-Light';
  font-style: normal;
  font-weight: 325;
  font-size: 19px;
  line-height: 33px;
  text-align: center;
  color: #333333;
  margin-bottom: 50px;
}

.avg-note {
  width: 285px;
  font-family: 'OpenSans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: rgba(0, 0, 0, 0.47);
  margin: 0 auto;
  margin-bottom: 40px;
}

.avg-guide-link {
  color: #173945;
  font-family: 'klinicslabbold';
  font-size: 19px;
  font-weight: 400;
  line-height: 22.8px;
  text-decoration: none;
}

.avg-guide-link a {
  color: #173945;
}

.avg-get-guide {
  margin: 0 0 0 auto;

  @media screen and (min-width: 1921px) {
    margin: 0 0 0 10rem;
  }
}

.avg-guide {
  margin-top: 115px;
  margin-left: -140px;
  position: absolute;
  transform: rotate(-10deg);
  box-shadow: -5px 5px 7px -3px rgba(0, 0, 0, 0.15);
  z-index: 100;
  width: 23rem;
  height: 31rem;

  @media screen and (max-width: 1380px) {
    width: calc(23rem / 1.25);
    height: calc(31rem / 1.25);
  }
}

.avg-order-form {
  display: inline-block;
  margin-top: 110px;
  margin-left: 186px;
  background: #f7f6f1;
  mix-blend-mode: normal;
  opacity: 0.95;
  padding-bottom: 3.5rem;

  @media screen and (max-width: 1380px) {
    margin-top: 55px;
    margin-left: 100px;
  }
}

.avg-order-form-content {
  display: flex;
  flex-direction: column;
  margin-left: 0;
  margin-right: auto;

  @media screen and (min-width: 1921px) {
    margin-right: 20vmax;
  }
}

.avg-order-form-header {
  display: flex;
  flex-wrap: nowrap;
  gap: 1.5rem;
  margin-top: 1.25rem;
  margin-bottom: 0.75rem;
}

.avg-form-section {
  width: 500px;
  margin-left: 100px;
  text-align: left;
}

.avg-legend {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.avg-form-info-active,
.avg-form-info-inactive,
.avg-form-address-active,
.avg-form-address-inactive,
.avg-form-misc-active,
.avg-form-misc-inactive {
  margin-left: 12px;
  margin-bottom: 2px;
  color: #f7f6f1;
  font-family: 'KlinicSlabmedium';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
}

.avg-form-info-bubble-active,
.avg-form-address-bubble-active,
.avg-form-misc-bubble-active,
.avg-form-info-bubble-inactive,
.avg-form-address-bubble-inactive,
.avg-form-misc-bubble-inactive {
  width: 31px;
  height: 31px;
  background: #173945;
  border-radius: 50%;
  z-index: -1;

  position: absolute;
}

.avg-form-info-inactive,
.avg-form-address-inactive,
.avg-form-misc-inactive,
.avg-form-info-bubble-inactive,
.avg-form-address-bubble-inactive,
.avg-form-misc-bubble-inactive {
  opacity: 0.6;
}

.avg-form-info-inactive-txt,
.avg-form-address-inactive-txt,
.avg-form-misc-inactive-txt {
  color: rgba(23, 57, 69, 0.6);
}

.avg-form-info-active-txt,
.avg-form-info-inactive-txt,
.avg-form-address-active-txt,
.avg-form-address-inactive-txt,
.avg-form-misc-active-txt,
.avg-form-misc-inactive-txt {
  display: contents;
}

.avg-order-form-field,
.avg-order-form-field-short {
  width: 404px;
  height: 53px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #173945;
  border-radius: 3px;
  margin-top: 1.5rem;
  padding-left: 15px;
  font-size: 14px;
  line-height: 16px;
}

.avg-order-form-field-short {
  width: 195px;
  margin-right: 15px;
}

.avg-error-message {
  margin-top: 2px;
  margin-bottom: 0px;
  font-size: 0.7em;
  height: 1px;
}

/* .avg-city-error,
.avg-zip-error {
  margin-left: 215px;
} */

.avg-state-placeholder {
  position: relative;
  left: 18px;
  font-size: 14px;
  color: gray;
}

.avg-states {
  margin-top: 0px;
  margin-left: -34px;
}

.avg-accept-newsletter {
  display: inline;
}

.avg-accept-newsletter-input {
  margin-top: 20px;
}

.avg-misc-options {
  text-align: left;
}

.avg-accept-newsletter-txt {
  font-family: 'IdealSans-Book';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #173945;
  margin-left: 25px;
  margin-top: -25px;
}

.avg-yes-txt {
  font-family: 'IdealSans-Semibold';
}

.avg-select-interests-title,
.avg-select-interests-optional {
  font-family: 'IdealSans-Semibold';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 16px;
  color: #173945;
  margin-top: 38px;
}

.avg-select-interests-optional {
  font-family: 'IdealSans-Book';
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
}

.avg-brochure-options {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  grid-auto-flow: row;
  grid-template-areas:
    'ac fd outdoor'
    'beaches history sd'
    'crl music sports'
    'yrg . .';
  margin-top: 20px;
  height: 115px;
}

.ac,
.fd,
.outdoor,
.beaches,
.history,
.sd,
.crl,
.music,
.sports,
.yrg {
  font-family: 'IdealSans-Light';
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  color: #173945;
}

.avg-confirmation-title {
  width: 491px;
  height: 132px;
  font-family: 'KlinicSlabbold';
  font-style: normal;
  font-weight: 400;
  font-size: 60px;
  line-height: 62px;
  text-align: center;
  color: #173945;
  margin-top: 75px;
  margin-left: 50px;
}

.avg-form-back-btn,
.avg-form-back-submit-btn {
  margin-left: 212px;
  margin-top: 30px;
  float: left;
  color: #173945;
  font-size: 16px;
}

.avg-form-back-btn:hover,
.avg-form-back-submit-btn:hover {
  text-decoration: underline;
  cursor: pointer;
}

.avg-submit-btn,
.avg-confirmation-btn,
.avg-download-btn {
  width: 100px;
  height: 40px;
  background: #173945;
  border: 1px solid #4e97b2;
  border-radius: 5px;
  color: #f6f4ee;
  font-family: 'KlinicSlabbold';
  font-style: normal;
  font-weight: 400;
  font-size: 19px;
  line-height: 23px;
  margin-top: 23px;
  margin-right: 95px;
  float: right;
  padding: 0;
}

.avg-submit-btn:hover,
.avg-confirmation-btn:hover,
.avg-download-btn:hover {
  cursor: pointer;
  box-shadow: 0 2px 27px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease-in-out;
}

.avg-confirmation-btn {
  margin-top: 110px;
  margin-right: 0px;
  width: auto;
  float: none;
  padding-inline: 1rem;
}

.avg-download-btn {
  width: 190px;
  margin-top: -20px;
  margin-right: 0;
  float: none;
  font-size: 14px;
}

.avg-download-icon {
  vertical-align: sub;
  margin-right: 5px;
}

.avg-title {
  justify-self: center;
  align-self: center;
  max-width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.avg-need-more {
  font-family: 'KlinicSlabbold';
  font-style: normal;
  font-weight: 400;
  font-size: 39px;
  line-height: 40px;
  text-align: center;
  color: #1a3138;
  margin: 0 auto;
  margin-bottom: 2rem;
}

.avg-download-tx {
  max-width: 75%;
  font-family: 'KlinicSlabmedium';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  text-align: center;
  color: #1a3138;
}

.avg-brochures {
  display: flex;
  grid-area: 3 / 1 / 4 / 3;
  width: 70%;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
}

.avg-brochure-items {
  justify-content: center;
}

.avg-brochure-row {
  margin-bottom: 25px;
}

.avg-brochure-img {
  width: 100%;
  border-radius: 5px 5px 0px 0px;
}

.avg-brochure-caption {
  height: 125px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.05);
  margin: 0 auto;
  background: #fff;
  border-radius: 0px 0px 8px 8px;
  font-family: 'KlinicSlabmedium';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 26px;
  color: #173945;
  box-shadow: -1px 4px 5px 0px rgb(0 0 0 / 5%);
}

.avg-brochure-title {
  height: 45px;
  padding: 0 6px;
  line-height: 21px;
  display: grid;
  justify-content: center;
  align-items: center;
  font-size: 21px;
}

@media only screen and (max-width: 1280px) {
  .avg-header {
    display: flex;
    flex-direction: column;
  }

  .avg-intro {
    margin-left: auto;
  }

  .avg-header {
    width: 100%;
    height: auto;
    flex-direction: column;
  }

  .avg-al-vacation-heading {
    width: 600px;
  }

  .avg-al-vacation-tx {
    width: 595px;
    margin-bottom: 15px;
  }

  .avg-note {
    width: 348px;
  }

  .avg-guide {
    position: relative;
    margin-top: 0;
    margin-bottom: 20px;
    margin-left: 10px;
    width: 130px;
    height: 176px;
  }

  .avg-order-form {
    margin-top: -40px;
    margin-left: 0px;
  }

  .avg-form-address-active-txt,
  .avg-form-address-inactive-txt,
  .avg-form-info-active-txt,
  .avg-form-info-inactive-txt,
  .avg-form-misc-active-txt,
  .avg-form-misc-inactive-txt {
    font-size: 18px;
  }

  .avg-form-info-active,
  .avg-form-info-inactive,
  .avg-form-address-active,
  .avg-form-address-inactive,
  .avg-form-misc-active,
  .avg-form-misc-inactive {
    margin-right: 3px;
  }

  .avg-form-back-btn {
    margin-left: 155px;
  }

  .avg-submit-btn {
    margin-right: 95px;
  }

  .avg-confirmation-btn {
    margin-right: 0px;
    margin-top: 0px;
  }

  .avg-confirmation-title {
    margin: 75px auto;
  }

  .avg-form-back-submit-btn {
    margin-top: 9px;
    margin-left: 170px;
  }

  .avg-submit-btn-last {
    margin-top: 0px;
    margin-right: 65px;
  }
}

@media only screen and (max-width: 1280px) {
  .avg-order-form-header {
    gap: 1rem;
  }

  .avg-al-vacation-heading,
  .avg-al-vacation-tx,
  .avg-note,
  .avg-guide-link {
    margin-bottom: 1rem;
  }

  .avg-intro {
    padding-inline: 1rem;
    height: auto;
    margin-bottom: 0;

    & > * {
      height: auto;
    }
  }

  .avg-get-guide,
  .avg-order-form,
  .avg-form-section,
  .avg-title,
  .avg-al-vacation-tx,
  .avg-intro,
  .avg-al-vacation-heading {
    width: 100%;
  }

  .avg-order-form {
    padding-bottom: 2rem;
    height: auto;
  }

  .avg-form-section {
    margin-inline: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 1rem;
    flex-direction: column;
    align-content: center;

    .avg-legend {
      margin-inline: 0;
    }

    & > span {
      display: flex;
      flex-direction: column;
      width: min-content;
      align-items: flex-start;
    }

    .avg-submit-btn {
      width: 6.5rem;
      min-width: 0;
      margin: 0;
    }

    .avg-form-back-btn {
      margin: 0;
    }

    .avg-form-buttons {
      display: flex;
      justify-content: flex-end;
      gap: 1rem;
      margin-top: 1.5rem;
      align-items: center;
      margin-left: auto;
    }
  }

  .avg-newsletter-question {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    margin-top: 1rem;

    .avg-accept-newsletter-input {
      margin: 0;
      height: 1.125rem;
      width: 2.125rem;
      min-width: 0;
    }

    .avg-accept-newsletter-txt {
      margin: 0;
    }
  }

  .avg-brochure-options {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 1rem;
  }

  .avg-confirmation-title {
    width: 100%;
    padding-inline: 2rem;
  }

  .avg-order-form-btn-group-sm {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  .avg-order-form-header {
    justify-content: center;
  }

  .avg-order-form-field-short {
    margin-inline: 0;
  }

  .avg-misc-options {
    gap: 1rem;
    align-items: center !important;
    width: 100% !important;
    padding-inline: 3rem;
  }

  .avg-download-tx {
    margin-bottom: 1rem;
    height: auto;
    margin-inline: auto;
    padding: 1rem;
    width: 100%;
  }

  .avg-brochure-caption {
    width: 100%;
    flex-direction: column;
    gap: 1rem;
  }

  .avg-title,
  .avg-need-more,
  .avg-download-tx {
    max-width: 100%;
  }

  .avg-title {
    padding-inline: 1rem;
  }
}

input {
  min-width: 0;
}

.avg-order-form-btn-group-sm {
  display: flex;
}
</style>
